export const FromPaymentScreenActionType = {
	FromPaymentScreen: "FromPaymentScreen",
};
